import { createContext } from 'react';
import {
  BackfillRecipesService,
  BinderCostRecordsService,
  BinderDeliveriesService,
  BinderSuppliersService,
  BreakingSchedulesService,
  BreakingTestsService,
  ClientsService,
  CustomReportsService,
  FlushRecipesService,
  HistoricBreakingTestService,
  InvitationsService,
  MineModelsService,
  NotificationsService,
  PoursService,
  PourTypesService,
  ProjectsService,
  PublicPoursService,
  PublicStopeNotesService,
  QaqcSamplesService,
  ScenariosService,
  Service,
  StopeBackfillingService,
  StopeNotesService,
  TeamRolesService,
  TeamsService,
  UserDashboardsService,
  UserNotificationsService,
  UsersService
} from './api';
import { AccountAdminService } from './accountAdminApi';
import { AnalyticsService } from './analyticsApi';

export interface IApiContext {
  clients: ClientsService,
  projects: ProjectsService,
  users: UsersService,
  teams: TeamsService,
  invitations: InvitationsService,
  mineModels: MineModelsService,
  recipes: BackfillRecipesService,
  flushRecipes: FlushRecipesService,
  pours: PoursService,
  teamRoles: TeamRolesService,
  stopes: StopeBackfillingService,
  pourTypes: PourTypesService,
  stopeNotes: StopeNotesService,
  contentApi: Service,
  binderCostRecords: BinderCostRecordsService,
  binderDeliveries: BinderDeliveriesService,
  binderSuppliers: BinderSuppliersService,
  userNotifications: UserNotificationsService,
  notifications: NotificationsService,
  breakingSchedules: BreakingSchedulesService,
  breakingTests: BreakingTestsService,
  historicBreakingTests: HistoricBreakingTestService,
  publicPours: PublicPoursService,
  publicStopeNotes: PublicStopeNotesService,
  scenarios: ScenariosService,
  customReports: CustomReportsService,
  qaqcSamples: QaqcSamplesService,
  analytics: AnalyticsService,
  userDashboards: UserDashboardsService,
  accountAdmin: AccountAdminService,
}

const ApiContext = createContext<IApiContext | null>(null);

export default ApiContext;
